import React, { Dispatch, SetStateAction } from "react";
import PropTypes from "prop-types";

import Modal from "./base/Modal";
import ModalBody from "./base/ModalBody";
import ModalHeader from "./base/ModalHeader";

interface ConfirmActionModalProps {
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title: string;
  message: string;
}

const InfoModal: React.FC<ConfirmActionModalProps> = ({
  isOpen,
  setOpen,
  title,
  message,
}) => {
  return (
    <Modal isOpen={isOpen} setOpen={setOpen} size="md">
      <ModalHeader setOpen={setOpen}>{title}</ModalHeader>
      <ModalBody className="flex flex-col gap-2">
        <p>{message}</p>
      </ModalBody>
    </Modal>
  );
};

InfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default InfoModal;
